module.exports = "/assets/data/d4fa7bf612e2e52be007b5e8102e6594-BT70.data.json";